module.exports = __webpack_public_path__ + "img/icon_3_38.fc67fc16.png";